import Stack from "@/tpo/Stack";

import NavigationInstance from "./Navigation";

export default function LearningHubListSidebar({ filterDesktop }) {
  return (
    <Stack gap={28} flexShrink={0} alignSelf="flex-start" width={["100%", "auto"]}>
      <NavigationInstance />
      {filterDesktop}
    </Stack>
  );
}
